export default {"src":"/_next/static/media/outro.574d20c9.gif","height":500,"width":500,"blurWidth":0,"blurHeight":0};